import Axios, { type AxiosInstance } from 'axios';
import type { IMsalInstance } from '@/authSetup.ts';
import { standardArrayHandlingAxios } from '@/lib/standardArrayHandlingAxios';

export function createAuthenticatedAxios(
  msalInstance: IMsalInstance,
  baseURL: string,
): AxiosInstance {
  const axiosInstance = Axios.create({
    baseURL,
    paramsSerializer: standardArrayHandlingAxios,
    validateStatus: (status) =>
      (status >= 200 && status < 300) || status === 401,
  });

  axiosInstance.interceptors.request.use(async (config) => {
    const token = await msalInstance.selectAccountAndTryToAcquireToken();
    if (token !== null) {
      config.headers.set('Authorization', `Bearer ${token}`);
    }
    return config;
  });

  axiosInstance.interceptors.response.use((response) => {
    if (response.status === 401) {
      throw new Response(null, { status: 401 });
    }
    return response;
  });

  return axiosInstance;
}
